import { token } from '@atlaskit/tokens';
import { css } from '@emotion/core';
import { N700, N200A, N0 } from '@atlaskit/theme/colors';

import {
  flexCenter,
  SPACE_MINIMUM,
  flexSpace,
  SPACE_COMPACT,
  textTransformCapitalize,
  flexStart,
  spaceGapMinimum,
  SPACE_COZY,
} from '@/styles';

const popupWidth = 730;

export const showDetailsIconStyles = css`
  ${flexCenter};
  margin-right: ${SPACE_MINIMUM}px;
  margin-left: -2px;
`;

export const sloQualityDetailViewStyles = css`
  h5 {
    font-weight: 500;
  }
  width: ${popupWidth}px;
`;

export const infoBarStyles = css`
  div {
    align-items: baseline;
    h6 {
      font-size: 11px;
      position: static; // unset the hacky position shift
    }
    img {
      transform: scale(0.8);
    }
  }
`;

// header and row shared styles
export const resultRowStyles = [
  flexSpace,
  css`
    & > div {
      &:first-of-type {
        flex-grow: 1;
        min-width: 0;
      }
      &:nth-of-type(2) {
        width: 60px;
      }
      &:nth-of-type(3) {
        width: 80px;
      }
      &:nth-of-type(4) {
        width: 100px;
      }
      &:nth-of-type(5) {
        width: 100px;
      }
    }
  `,
];

export const resultItemStyles = css`
  a {
    font-size: 12px;
    font-weight: 500;
    ${flexStart};
    ${spaceGapMinimum};
  }
`;

export const itemTitleStyles = css`
  ${textTransformCapitalize};
  font-size: 12px;
  font-weight: 500;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const itemContentStyles = css`
  h5 {
    font-size: 12px;
    font-weight: 600;
    color: ${token('color.text.subtle', N700)};
  }
  code {
    font-size: 13px;
  }
`;

export const itemMetadataTableStyles = css`
  padding-left: 0;
  margin-top: 20px;
  list-style-type: none;
  margin-top: 8px !important;
  border-radius: 3px;
  background-color: ${token('color.background.neutral.subtle.hovered', N200A)};
  & > li {
    margin-top: 0;
    align-items: stretch;
    color: ${token('color.text.subtle', N700)};
    code {
      ${flexStart};
      font-size: 12px;
      padding: ${SPACE_COMPACT}px ${SPACE_COZY}px;
      border-bottom: 1px solid ${token('color.text.inverse', N0)};
      border-right: 1px solid ${token('color.text.inverse', N0)};
      box-sizing: border-box;
      &:first-of-type {
        width: 200px;
        font-weight: 600;
        font-size: 11px;
      }
      &:last-of-type {
        width: calc(100% - 200px);
      }
    }
  }
`;

export const resultsScrollStyles = css`
  max-height: calc(100vh - 300px);
`;
